import React, { SVGProps } from 'react';
import IconType from './iconType';

type Props = React.PropsWithoutRef<SVGProps<SVGSVGElement>> & IconType;

const FilledCross = React.forwardRef<SVGSVGElement, Props>(function FilledCross(
  { width = 16, height = 16, color = 'white', onClick },
  ref
) {
  return (
    <svg
      onClick={onClick}
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect width="16.0001" height="16" rx="8" fill={color} />
      <path d="M5.81641 10.1839L10.1801 5.82031" stroke="#616161" strokeWidth="1.23637" strokeLinecap="round" />
      <path d="M5.81641 5.82031L10.1801 10.1839" stroke="#424242" strokeWidth="1.23637" strokeLinecap="round" />
    </svg>
  );
});

export default FilledCross;
